import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import * as _ from 'lodash';
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})

export class PaginationComponent {

  @Input() totalNumberOfItems: number;
  @Input() pageSize: number;

  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();



  private pageSizes: any[] = [
    {
      label: '5',
      value: '5'
    },
    {
      label: '10',
      value: '10'
    },
    {
      label: '20',
      value: '20'
    },
    {
      label: '50',
      value: '50'
    },
    {
      label: '100',
      value: '100'
    }
  ];
  private paginationForm: UntypedFormGroup;

  public maximumNumberOfPages: number;

  constructor(
    private _fb: UntypedFormBuilder,
    private _translateService: TranslateService
  ) {
    this.paginationForm = this._fb.group({
      itemsPerPage: [
        {
          value: '10',
          disabled: false,

        },
        Validators.required,
      ],
      currentPage: [
        {
          value: 1,
          disabled: false
        },
        Validators.required
      ]
    })
  }

  ngOnInit() {
    this._initForm();
    this._setUpValueChangeDetection();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.totalNumberOfItems) {
      this.maximumNumberOfPages = Math.ceil(changes.totalNumberOfItems.currentValue / this.paginationForm.controls.itemsPerPage.value);
    }
  }

  public getPageSizes() {
    return this.pageSizes;
  }

  public getPaginationForm() {
    return this.paginationForm;
  }

  public getMaximumNumberOfPages() {
    return this.maximumNumberOfPages;
  }

  public setCurrentPageValue(value) {
    this.paginationForm.controls.currentPage.setValue(value);
  }

  public goToPage(forward: boolean) {
    if (forward) {
      if ((this.paginationForm.controls.itemsPerPage.value * this.paginationForm.controls.currentPage.value) >= this.totalNumberOfItems) {
        return
      } else {
        this.paginationForm.controls.currentPage.setValue(Number(this.paginationForm.controls.currentPage.value) + 1);
        this.pageChange.emit(this.paginationForm.controls.currentPage.value);
      }
    } else {
      if ((this.paginationForm.controls.currentPage.value - 1) <= 0) {
        return
      } else {
        this.paginationForm.controls.currentPage.setValue(Number(this.paginationForm.controls.currentPage.value) - 1);
        this.pageChange.emit(this.paginationForm.controls.currentPage.value);
      }
    }
  }

  public checkChange(value) {
    if (value > Math.ceil(this.totalNumberOfItems / this.paginationForm.controls.itemsPerPage.value)) {
      this.paginationForm.controls.currentPage.setValue(Math.ceil(this.totalNumberOfItems / this.paginationForm.controls.itemsPerPage.value));
      this.pageChange.emit(this.paginationForm.controls.currentPage.value);
    } else {
      this.pageChange.emit(value);
    }
  }

  private _initForm() {
    const pageSize = _.find(this.pageSizes, {value: this.pageSize.toString()});
    this.paginationForm.controls.itemsPerPage.setValue(pageSize.value);
  }

  private _setUpValueChangeDetection() {
    this.paginationForm.controls.itemsPerPage.valueChanges
      .subscribe((item) => {
        this._onPageSizeChange(Number(item));
      });
  }

  private _onPageSizeChange(itemsPerPage) {
    this.pageSizeChange.emit(itemsPerPage);
    this.maximumNumberOfPages = Math.ceil(this.totalNumberOfItems / itemsPerPage);
  }
}
